import { render, staticRenderFns } from "./QuestionsWidget.vue?vue&type=template&id=38adf708&scoped=true&"
import script from "./QuestionsWidget.vue?vue&type=script&lang=js&"
export * from "./QuestionsWidget.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsWidget.vue?vue&type=style&index=0&id=38adf708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38adf708",
  null
  
)

export default component.exports